import { IconDislike16, IconLike16 } from '@cian/ui-kit';
// eslint-disable-next-line import/default
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { trackDislike, trackLike } from './tracking';
import { ChatbotButton } from '../../components/ChatbotButton';
import { ChatbotMessageLikesLayout } from '../../components/ChatbotMessageLikesLayout';
import { IconStrokeDislike16 } from '../../components/Icons/IconStrokeDislike16';
import { IconStrokeLike16 } from '../../components/Icons/IconStrokeLike16';
import { IMessageOfferSchema } from '../../repositories/cian-chat-bot/entities/offer/MessageOfferSchema';
import { EReaction } from '../../repositories/cian-chat-bot/entities/offer_reaction/OfferReactionSchema';
import { applyOfferReaction } from '../../thunks/chatbot';

interface IChatbotMessageLikesContainer {
  offer: IMessageOfferSchema;
  communicationId?: string;
}

export const ChatbotMessageLikesContainer = ({ offer, communicationId }: IChatbotMessageLikesContainer) => {
  const [reaction, setReaction] = useState<EReaction | undefined>(undefined);
  const dispatch = useDispatch();

  useEffect(() => {
    setReaction(offer?.reaction);
  }, [offer]);

  const handleLikeClick = useCallback(() => {
    if (!offer) {
      return;
    }

    const nextReaction = reaction !== EReaction.Like ? EReaction.Like : undefined;

    setReaction(nextReaction);
    trackLike(offer.realtyOfferId, nextReaction, communicationId);
    dispatch(
      applyOfferReaction({
        offerId: offer.realtyOfferId,
        reaction: nextReaction,
      }),
    );
  }, [dispatch, offer, reaction]);

  const handleDislikeClick = useCallback(() => {
    if (!offer) {
      return;
    }

    const nextReaction = reaction !== EReaction.Dislike ? EReaction.Dislike : undefined;

    setReaction(nextReaction);
    trackDislike(offer.realtyOfferId, nextReaction, communicationId);
    dispatch(
      applyOfferReaction({
        offerId: offer.realtyOfferId,
        reaction: nextReaction,
      }),
    );
  }, [dispatch, offer, reaction]);

  return (
    <ChatbotMessageLikesLayout>
      <ChatbotButton
        theme={'fill_white_primary'}
        beforeIcon={
          reaction === EReaction.Like ? (
            <IconLike16 color={'fill_success_primary__active_100'} />
          ) : (
            <IconStrokeLike16 color={'gray_icons_100'} />
          )
        }
        onClick={handleLikeClick}
      />

      <ChatbotButton
        theme={'fill_white_primary'}
        beforeIcon={
          reaction === EReaction.Dislike ? (
            <IconDislike16 color={'fill_error_primary_active_100'} />
          ) : (
            <IconStrokeDislike16 color={'gray_icons_100'} />
          )
        }
        onClick={handleDislikeClick}
      />
    </ChatbotMessageLikesLayout>
  );
};
